import { render } from "./RiDownload.vue?vue&type=template&id=6517ed55"
import script from "./RiDownload.vue?vue&type=script&lang=js"
export * from "./RiDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiDownload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6517ed55"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6517ed55', __exports__)) {
    api.reload('6517ed55', __exports__)
  }
  
  module.hot.accept("./RiDownload.vue?vue&type=template&id=6517ed55", () => {
    api.rerender('6517ed55', render)
  })

}


export default __exports__